













































































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { AppData, CareGiver, MARITAL_STATUS } from "@/models/app-data";
import { required } from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { CareGiver3Content } from "@/models/content/caregiver-3";

@Component({
  components: {
    FooterButton,
  },
  validations: {
    maritalStatus: {
      required,
    },
    languageOptionIsPicked: {
      checked: (value) => value === true,
    },
    otherLangugageIsOk: {
      checkOtherLanguage(): boolean {
        const model = this as CareGiver3;
        if (model.otherChecked === true) {
          return model.otherLanguage != null && model.otherLanguage.length > 0;
        } else {
          return true;
        }
      },
    },
  },
})
export default class CareGiver3 extends Mixins(CommonMixin) {
  content: CareGiver3Content = {} as CareGiver3Content;
  appData = {} as AppData;
  maritalStatus = MARITAL_STATUS.NONE;
  single = MARITAL_STATUS.SINGLE;
  married = MARITAL_STATUS.MARRIED;
  divorced = MARITAL_STATUS.DIVORCED;
  PercentDone = 30;
  englishChecked = false;
  spanishChecked = false;
  arabicChecked = false;
  otherChecked = false;
  otherLanguage = "";
  languageOptionIsPicked = false;
  textDirection = "ltr";

  @Watch("englishChecked")
  @Watch("spanishChecked")
  @Watch("arabicChecked")
  @Watch("otherChecked")
  onLanguageSelected(): void {
    this.languageOptionIsPicked =
      this.englishChecked ||
      this.spanishChecked ||
      this.arabicChecked ||
      this.otherChecked;
  }

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getCareGiver3Content();
      this.textDirection = contentService.TextDirection();

      this.appData = this.getAppData();

      if (this.appData != null) {
        if (this.appData.careGiver != null) {
          this.maritalStatus = this.appData.careGiver.maritalStatus;
          this.englishChecked = this.appData.careGiver.speakEnglish;
          this.spanishChecked = this.appData.careGiver.speakSpanish;
          this.arabicChecked = this.appData.careGiver.speakArabic;
          this.otherChecked = this.appData.careGiver.speakOther;
          this.otherLanguage = this.appData.careGiver.otherLanguage;
        }
        this.putWorkflowStep( this.appData.workflowId, "CareGiver3") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  disableNext(): boolean {
    return this.$v.$invalid;
  }

  public handleNextPageEvent(): void {
    this.saveData();
    this.$router.push({ path: "Child1" });
  }

  saveData(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    if (this.appData.careGiver == null) {
      this.appData.careGiver = {} as CareGiver;
    }
    this.appData.careGiver.maritalStatus = this.maritalStatus;
    this.appData.careGiver.speakEnglish = this.englishChecked;
    this.appData.careGiver.speakSpanish = this.spanishChecked;
    this.appData.careGiver.speakArabic = this.arabicChecked;
    this.appData.careGiver.speakOther = this.otherChecked;
    if (this.appData.careGiver.speakOther === true) {
      this.appData.careGiver.otherLanguage = this.otherLanguage;
    } else {
      this.appData.careGiver.otherLanguage = "";
    }
    this.saveAppData(this.appData);
  }
}
